import React from "react";
import {
  Container,
  Card,
  Button,
  Row,
  Col,
  Form,
  Table,
  Alert,
  Spinner,
} from "react-bootstrap";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyBBzepSPN2wdZfvan5GgyeeIREAV6k5BaU",
  authDomain: "loftie-4f472.firebaseapp.com",
  databaseURL: "https://loftie-4f472.firebaseio.com",
  projectId: "loftie-4f472",
  storageBucket: "loftie-4f472.appspot.com",
  messagingSenderId: "302939981606",
  appId: "1:302939981606:web:7fcb10ed6fe46fa437a3e7",
  measurementId: "G-L8VGQXX28P",
};

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);

function MacLookUp() {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [hasSearched, setHasSearched] = useState(false);

  const handleSearch = async () => {
    if (!searchTerm.trim()) {
      setError("Please enter a serial number");
      return;
    }

    setLoading(true);
    setError("");
    setHasSearched(true);

    try {
      const q = query(
        collection(db, "device-mac-sn"),
        where("Serial_No", "==", searchTerm.trim())
      );

      const querySnapshot = await getDocs(q);
      const results = [];

      querySnapshot.forEach((doc) => {
        results.push({
          id: doc.id,
          ...doc.data(),
        });
      });

      setSearchResults(results);
    } catch (err) {
      setError("Error searching database: " + err.message);
      console.error("Error searching:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className="MacLookUp">
      <Container>
        <div style={{ height: "45px" }}></div>
        <h1 className="text-center mb-4" style={{ color: "#F0D6B5" }}>
          Mac Address Search
        </h1>

        <Row className="justify-content-center">
          <Col md={10}>
            <Card>
              <Card.Body>
                <div className="text-center mb-4">
                  <FontAwesomeIcon
                    icon={faSearch}
                    size="3x"
                    style={{ color: "#F0D6B5" }}
                  />
                </div>

                <Form.Group className="mb-3">
                  <Form.Label>Serial Number</Form.Label>
                  <Form.Control
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="Enter serial number"
                  />
                </Form.Group>

                <div className="text-center">
                  <Button
                    variant="primary"
                    onClick={handleSearch}
                    disabled={loading}
                    style={{
                      backgroundColor: "#635956",
                      borderColor: "#635956",
                    }}
                  >
                    {loading ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        Searching...
                      </>
                    ) : (
                      <>
                        <FontAwesomeIcon icon={faSearch} className="me-2" />
                        Search
                      </>
                    )}
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Error Alert */}
        {error && (
          <Row className="mt-3 justify-content-center">
            <Col md={10}>
              <Alert variant="danger">{error}</Alert>
            </Col>
          </Row>
        )}

        {/* Results Table */}
        {hasSearched && !loading && !error && (
          <Row className="mt-3 justify-content-center">
            <Col md={10}>
              <Card>
                <Card.Body>
                  <Card.Title className="text-center mb-4">
                    Search Results
                  </Card.Title>

                  {searchResults.length === 0 ? (
                    <Alert variant="info" className="text-center">
                      No devices found with serial number:{" "}
                      <strong>{searchTerm}</strong>
                    </Alert>
                  ) : (
                    <>
                      <Alert variant="success" className="text-center">
                        Found {searchResults.length} device(s) with serial
                        number: <strong>{searchTerm}</strong>
                      </Alert>

                      <div className="table-responsive">
                        <Table striped bordered hover>
                          <thead style={{ backgroundColor: "#F0D6B5" }}>
                            <tr>
                              <th>MAC Address</th>
                              <th>Serial Number</th>
                              <th>Device</th>
                              <th>Color</th>
                            </tr>
                          </thead>
                          <tbody>
                            {searchResults.map((device, index) => (
                              <tr key={device.id || index}>
                                <td>
                                  <strong style={{ color: "#635956" }}>
                                    {device.MAC_Address ||
                                      device["MAC Address"] ||
                                      "not listed"}
                                  </strong>
                                </td>
                                <td>{device.Serial_No || "not listed"}</td>
                                <td>
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color: "#635956",
                                    }}
                                  >
                                    {device.type
                                      ? device.type.charAt(0).toUpperCase() +
                                        device.type.slice(1).toLowerCase()
                                      : "not listed"}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    style={{
                                      textTransform: "capitalize",
                                      color:
                                        device.color?.toLowerCase() === "white"
                                          ? "#666"
                                          : device.color,
                                    }}
                                  >
                                    {device.color || "not listed"}
                                  </span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}

        <Row className="mt-3 justify-content-center">
          <Col md={10}>
            <div className="text-center">
              <a href="/" style={{ color: "#635956", textDecoration: "none" }}>
                ← Back to Dashboard
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MacLookUp;
